(() => {
  function getVariantsJSON(root) {
    // Dawn typically includes a JSON script inside/near the variant picker
    const script =
      root.querySelector('script[type="application/json"][data-variants]') ||
      root.querySelector('variant-selects script[type="application/json"]') ||
      root.querySelector('variant-radios script[type="application/json"]') ||
      root.querySelector('product-variant-picker script[type="application/json"]');

    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCurrentOptions(root) {
    // Works for dropdowns + radios/buttons in Dawn-ish themes
    const selected = [];

    // dropdowns
    root.querySelectorAll('select[name^="options["]').forEach((sel) => {
      selected.push(sel.value);
    });

    // radios/buttons
    const fieldsets = root.querySelectorAll('fieldset');
    fieldsets.forEach((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) selected.push(checked.value);
    });

    return selected;
  }

  function setOptionVisibilityForPosition(root, positionIndex, allowedValues) {
    // DROPDOWN
    const select = root.querySelector(`select[name="options[${positionIndex + 1}]"]`);
    if (select) {
      Array.from(select.options).forEach((opt) => {
        if (!opt.value) return;
        const show = allowedValues.has(opt.value);
        opt.hidden = !show;
        opt.disabled = !show;
      });

      // If current selection became hidden, pick the first visible option
      if (select.selectedOptions.length && select.selectedOptions[0].hidden) {
        const firstVisible = Array.from(select.options).find((o) => o.value && !o.hidden && !o.disabled);
        if (firstVisible) select.value = firstVisible.value;
      }
    }

    // SWATCHES / BUTTON RADIOS
    // Common Dawn markup: inputs inside fieldsets
    const fieldset = root.querySelectorAll('fieldset')[positionIndex];
    if (fieldset) {
      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        const wrapper = input.closest('label') || input.closest('li') || input.parentElement;
        const show = allowedValues.has(input.value);
        if (wrapper) wrapper.style.display = show ? '' : 'none';
        input.disabled = !show;
      });

      // If checked radio got hidden/disabled, choose first visible
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && checked.disabled) {
        const firstEnabled = fieldset.querySelector('input[type="radio"]:not(:disabled)');
        if (firstEnabled) firstEnabled.click();
      }
    }
  }

  function recompute(root) {
    const variants = getVariantsJSON(root);
    if (!variants || !Array.isArray(variants) || variants.length === 0) return;

    const current = getCurrentOptions(root);

    // Build allowed values per option position (based on other selections)
    const optionCount = Math.max(
      ...variants.map((v) => (v.options ? v.options.length : 0))
    );

    for (let pos = 0; pos < optionCount; pos++) {
      const allowed = new Set();

      variants.forEach((v) => {
        if (!v.available) return;

        // Match all other selected positions except `pos`
        let ok = true;
        for (let i = 0; i < optionCount; i++) {
          if (i === pos) continue;
          const selectedVal = current[i];
          if (selectedVal && v.options && v.options[i] !== selectedVal) {
            ok = false;
            break;
          }
        }
        if (ok && v.options && v.options[pos]) allowed.add(v.options[pos]);
      });

      setOptionVisibilityForPosition(root, pos, allowed);
    }
  }

  function init() {
    // Target the product section. This keeps it from messing with other forms.
    document.querySelectorAll('product-info').forEach((productInfo) => {
      // The variant UI is usually inside productInfo
      const root = productInfo;

      // Run once
      recompute(root);

      // Re-run when the user changes anything variant-related
      root.addEventListener('change', (e) => {
        if (
          e.target.matches('select[name^="options["]') ||
          e.target.matches('input[type="radio"]')
        ) {
          // allow theme’s own variant logic to update, then recompute
          requestAnimationFrame(() => recompute(root));
        }
      });

      // Some themes fire custom events; harmless if they don't exist
      root.addEventListener('variant:change', () => recompute(root));
      root.addEventListener('variantChange', () => recompute(root));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
